export default __webpack_public_path__ + "static/media/viewIconTwo.b194c89e.svg";